import React from "react"
import { Field as FieldPrimitive } from "@base-ui/react/field"
import { cn } from "../utils"

// =============================================================================
// Styles
// =============================================================================
const descriptionStyles = [
  "font-sans text-sm leading-6 font-normal", // typography
  "text-gray-700" // greys with the label, which the field or the item owns
]

// =============================================================================
// Props
// =============================================================================
export type FieldDescriptionProps = {
  /** Description text */
  children?: React.ReactNode
  /** Additional CSS classes for layout */
  className?: string
}

// =============================================================================
// Component
// =============================================================================
/**
 * Secondary text explaining the control inside a `Field` or `Field.Item`.
 *
 * There is no `aria-describedby` to pass: the description registers its id
 * with the surrounding field, so a screen reader reads it after the control's
 * name. It stays out of the name itself, which is what a wrapping `<label>`
 * would get wrong.
 */
export const FieldDescription = React.forwardRef<
  HTMLParagraphElement,
  FieldDescriptionProps
>(function FieldDescription({ children, className }, ref) {
  return (
    <FieldPrimitive.Description
      ref={ref}
      data-slot="field-description"
      className={cn(descriptionStyles, className)}
    >
      {children}
    </FieldPrimitive.Description>
  )
})

FieldDescription.displayName = "Field.Description"
